import { render, staticRenderFns } from "./NivelProduto.vue?vue&type=template&id=9b747984&lang=html"
import script from "./NivelProduto.vue?vue&type=script&lang=js"
export * from "./NivelProduto.vue?vue&type=script&lang=js"
import style0 from "./NivelProduto.vue?vue&type=style&index=0&id=9b747984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports